import {useEffect, useState, useCallback} from "react";
import {isMobile} from "react-device-detect";
import {useNavigate} from "react-router-dom";

import {DEFAULT_CITY} from 'ultra/const/general';
import {isEmptyObj} from 'ultra/helpers/utils';
import {restorePath} from "ultra/helpers/route";
import {getClientCity} from 'ultra/configs/general';
import {isLibrary, hasFullAccess} from 'ultra/helpers/auth';

import Collapse from '@mui/material/Collapse';

import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {useNavigationStore} from '../../../../../../../../Stores/navigation';
import {useToasterStore} from '../../../../../../../../Stores/toster';
import {useConfigStore} from '../../../../../../../../Stores/config';
import {useBackdropPreloaderStore} from '../../../../../../../../Stores/backdropPreloader';

import PreloaderText from '../../../../../../../../Components/Preloaders/PreloaderText';
import Preloader from '../../../../../../../../Components/Preloaders/Preloader';
import AdaptiveDialog from '../../../../../../../../Components/Adaptive/Dialog';
import CurrencyFormated from '../../../../../../../../Components/CurrencyFormated'

import TitleWidget from '../../../../../../Widgets/Title'
import BreadcrumbsWidget from '../../../../../../Widgets/Breadcrumbs'
import ContentImage from '../../../../../../Widgets/ContentImage'
import CKEditorContent from '../../../../../../Widgets/CKEditorContent'
import FilterChip from '../../../../../../Widgets/FilterChip'
import Gallery from '../../../../../../Widgets/Gallery';

import {getTelegramUser} from '../../../../../../../../Helpers/telegram';
import {useGlobalCustomContext} from '../../../../../../../../Helpers/context';
import {isBelongsToLibrary} from '../../../../../../../../Helpers/library';

import {USER_ACTIONS} from '../../../../../../../Profile/Reducers/user';
import {NODE_ACTIONS} from '../../../../../../Reducers/node';

import {reserveBook, returnBook} from '../../../../../../../../Helpers/library'

import ShowActions from './ShowActions';
import ShowLinks from './ShowLinks';
import BookDetails from './BookDetails';

import RulesStep from './BookingSteps/RulesStep';
import SanctionsStep from './BookingSteps/SanctionsStep';
import PersonDetailsStep from './BookingSteps/PersonDetailsStep';
import DepositStep from './BookingSteps/DepositStep';
import DeliveryStep from './BookingSteps/DeliveryStep';
import DepositReturnStep from './BookingSteps/DepositReturnStep';
import DepositReturnFinalStep from './BookingSteps/DepositReturnFinalStep';
import FinalStep from './BookingSteps/FinalStep';

import './index.scss';

function scrollToTop() {
    isMobile ?
            window.document.getElementsByClassName('SwipeableDrawerContentWrapper')[0].scrollTo(0,0)
            :
            window.document.getElementsByClassName('MuiDialogContent-root')[0].scrollTo(0,0)
}

function Genres(props) {
    const {content, configs} = props;

    const navigate = useNavigate();

    const onGenreClick = useCallback((genre) => {
        if (genre) {
            const url = new URL(window.location.href.substring(0, window.location.href.lastIndexOf('/')));

            const filters = [];
            filters.push(["genre", "==", genre]);
            const str = JSON.stringify(filters);

            url.searchParams.set('filters', str);
            sessionStorage.setItem("filters", str);

            navigate(url.pathname + url.search);
        }
    })

    const onCategoryClick = useCallback((category) => {
        if (category) {
            const url = new URL(window.location.href.substring(0, window.location.href.lastIndexOf('/')));

            const filters = [];
            filters.push(["category", "==", category]);
            const str = JSON.stringify(filters);

            url.searchParams.set('filters', str);
            sessionStorage.setItem("filters", str);

            navigate(url.pathname + url.search);
        }
    })

    if (!content.genre) return <></>

    return <>
        {content.category && <div className={`labelWrap category`}>
            <span className="labelValue" >
                <div onClick={() => onCategoryClick(content.category)}>
                    <FilterChip value={content.category} config={configs.content.nodes['book'].fields.category} className="clickable"/>
                </div>
            </span>
        </div>}
        {content.genre && <div className={`labelWrap genre`}>
            <span className="labelValue" >
                {content.genre.map(genre => 
                    <div onClick={() => onGenreClick(genre)}>
                        <FilterChip key={genre} value={genre} config={configs.content.nodes['book'].fields.genre} className="clickable"/>
                    </div>
                )}
            </span>
        </div>}
    </>
}

export default function Template(props) {
    const {content, meta, permits, config, breadcrumbs} = props

    const navigate = useNavigate();

    const {configs} = useConfigStore();
    const {contentLoading} = useNavigationStore()
    const {showError} = useToasterStore();

    const [openGetBook, setOpenGetBook] = useState(false)
    const [openReturnBook, setOpenReturnBook] = useState(false)

    const [city] = useState(getClientCity(window) || DEFAULT_CITY)

    const [requestInProgress, setRequestInProgress] = useState()

    // const [readerManualInformation, setReaderManualInformation] = useState()
    const [deposit, setDeposit] = useState()
    // const [location, setLocation] = useState()

    // const [personalDataStep, setPersonalDataStep] = useState()
    const [showRulesStep, setShowRulesStep] = useState()
    const [showSanctionsStep, setShowSanctionsStep] = useState()
    const [depositStep, setDepositStep] = useState()
    const [deliveryStep, setDeliveryStep] = useState()
    const [finalStep, setFinalStep] = useState()
    const [finalReturnStep, setFinalReturnStep] = useState()
    const [returnStep, setReturnStep] = useState()
    const [belongsToLibrary, setBelongsToLibrary] = useState()

    const [telegram] = useState(getTelegramUser());
    // const {showPromt, closeToaster} = useToasterStore();
    const {hideBackdropPreloader, showBackdropPreloader} = useBackdropPreloaderStore()
    const {userState, userDispatch, nodeDispatch} = useGlobalCustomContext();


    function supportClickHandle() {   
        nodeDispatch({type: NODE_ACTIONS.POPUP_FORM, data: configs.links.support})
    }

    function updateContent() {
        userDispatch({type: USER_ACTIONS.USER_REFRESH_START})
        navigate(restorePath(content._uri))
    }

    function handleGetBookOpen() {
        if ((!userState?.user || isEmptyObj(userState?.user)) && !telegram) {
            // showPromt({
            //     snackbarMessage: 'Щоб взяти книгу, вам необхідно увійти в систему',
            //     onApproveHandler: () => {
            //         closeToaster();
            //         hideBackdropPreloader();
            //     },
            //     onCloseHandler: () => {
            //         closeToaster();
            //         hideBackdropPreloader();
            //     }
            // })
            userDispatch({type: USER_ACTIONS.LOGIN, data: 'Щоб взяти книгу, вам необхідно увійти в систему'})
            return;
        }

        setOpenGetBook(true)
        setShowRulesStep(true)
    }

    function acceptBaseRules() {
        setShowRulesStep(false)
        scrollToTop()
        // setPersonalDataStep(false)
        // scrollToTop()

        // if (belongsToLibrary) {
        //     setPersonalDataStep(true)
        // } else {
        //     setPersonalDataStep(false)
        //     setShowSanctionsStep(true)
        // }

        // setReaderManualInformation(data)

        setShowSanctionsStep(true)
    }

    // function submitPersonDetails(data) {
    //     setPersonalDataStep(false)
    //     scrollToTop()

    //     setReaderManualInformation(data)

    //     setShowSanctionsStep(true)
    // }

    function acceptFinalRules() {
        setShowSanctionsStep(false)
        scrollToTop()

        if (content?.deposit?.price && belongsToLibrary) {
            setDepositStep(true)
        }
        else {
            // reserveBookHandler(readerManualInformation, {})
            reserveBookHandler({})
        }
    }

    function sendDeposit(data) {
        setDeposit(data)
        setDepositStep(false)
        scrollToTop()

        // reserveBookHandler(readerManualInformation, data)
        // reserveBookHandler(data)
        setDeliveryStep(true)
    }

    function sendDelivery(delivery) {
        // setLocation(data)
        setDeliveryStep(false)
        scrollToTop()

        // reserveBookHandler(readerManualInformation, data)
        reserveBookHandler(delivery)
    }

    // book actions
    // function reserveBookHandler(readerInfo, deposit) {
    function reserveBookHandler(delivery) {
        setShowRulesStep(false)
        setDepositStep(false)
        setDeliveryStep(false)

        scrollToTop()

        setRequestInProgress(true)

        // reserveBook(city, content._uri, readerInfo, deposit)
        reserveBook(city, content._uri, delivery, deposit)
            .then(async () => {
                userDispatch({type: USER_ACTIONS.USER_REFRESH_START})

                setRequestInProgress(false)
                setFinalStep(true)

                setDeposit(undefined)
                // setLocation(undefined)
            })
            .catch((e) => {
                showError({snackbarMessage: e.message})

                setRequestInProgress(false)
                setFinalStep(false)
                setShowRulesStep(true)
            })
    }

    function returnBookHandler() {
        setReturnStep(false)

        setRequestInProgress(true)

        returnBook(city, content._uri)
            .then(() => {
                userDispatch({type: USER_ACTIONS.USER_REFRESH_START})

                setFinalReturnStep(true)
                setRequestInProgress(false)
            })
            .catch((e) => {
                showError({snackbarMessage: e.message})

                setReturnStep(true)
                setFinalReturnStep(false)
                setRequestInProgress(false)
            })
    }

    async function handleReturnBookOpen() {
        setFinalReturnStep(false);

        if (content?.deposit?.price) {
            setOpenReturnBook(true)

            setReturnStep(true)
        }
        else {
            showBackdropPreloader();

            try {
                await returnBook(city, content._uri)
                hideBackdropPreloader();

                nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
                userDispatch({type: USER_ACTIONS.USER_REFRESH_START});
            }
            catch (e) {
                hideBackdropPreloader();
                // nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_START});
                // userDispatch({type: USER_ACTIONS.USER_REFRESH_START});
            }
        }
    }

    // windows close
    function handleGetBookClose() {
        setOpenGetBook(false)

        setShowRulesStep(false)
        setShowSanctionsStep(false)
        // setPersonalDataStep(false)
        setDepositStep(false)
        setDeliveryStep(false)
        setFinalStep(false)

        if (finalStep) {
            updateContent()
        }
    }

    function handleReturnBookClose() {
        setOpenReturnBook(false)

        setReturnStep(false)
        setFinalStep(false)

        if (finalReturnStep) {
            updateContent()
        }
    }

    const onAuthorClick = useCallback((author) => {
        if (author) {
            const url = new URL(window.location.href.substring(0, window.location.href.lastIndexOf('/')));

            const filters = [];
            filters.push(["author", "==", author]);
            const str = JSON.stringify(filters);

            url.searchParams.set('filters', str);
            sessionStorage.setItem("filters", str);

            navigate(url.pathname + url.search);
        }
    })

    useEffect(() => {
        isBelongsToLibrary(city, content._uri)
            .then(res => {
                setBelongsToLibrary(res === 'true')
            })
    }, [])

    // const authorizedUser = (userState?.user?.displayName && !isEmptyMessengerData(userState?.user?.messenger)) || telegram

    return <div className='Book'>
        <TitleWidget permits={permits} content={content} config={config} breadcrumbs={breadcrumbs} hide={content.hideTitle} />
        <BreadcrumbsWidget links={breadcrumbs} hide={content.hideBreadcrumbs}/>

        {contentLoading && <PreloaderText />}

        {!contentLoading && <>
            <div className='posterWrap'>
                <ContentImage src="poster" image={content.poster} className="poster" />
                {!isMobile && <Gallery zoom content={content.gallery} />}
            </div>

            <div className='details'>
                {!isMobile && <Genres configs={configs} content={content}/>}

                {!contentLoading && <>
                    {content.author && <div className={`labelWrap author`}>
                        <span className="label">Автор:</span>
                        <span className="labelValue">
                            {content.author.map(author => <span className="pseudoLink" onClick={() => onAuthorClick(author)}>{author}</span>)}
                        </span>
                    </div>}

                    <div className={`labelWrap region`}>
                        <span className="label">Район:</span>
                        <span className="labelValue">
                            <FilterChip
                                className="textOnly"
                                value={content.region}
                                config={config?.childrenOptions?.['book']?.fields?.region || configs.content.nodes['book'].fields.region}
                            />
                        </span>
                    </div>

                    {!isMobile && content?.deposit && <div className={`labelWrap deposit`}>
                        <span className="label">Депозит:</span>
                        <span className="labelValue"><CurrencyFormated value={content?.idr?.price} currency={content?.idr?.currency}/> &nbsp;або&nbsp; <CurrencyFormated value={content?.deposit?.price} currency={content?.deposit?.currency}/></span>
                    </div>}

                    <div className={`labelWrap size`}>
                        <span className="label">Стан:</span>
                        <span className="labelValue">
                            {content.condition.join(', ')}
                        </span>
                    </div>

                    {!isMobile && <div className={`labelWrap size`}>
                        <span className="label">Розмір:</span>
                        <span className="labelValue">
                            <FilterChip
                                className="textOnly"
                                value={content.size}
                                config={config?.childrenOptions?.['book']?.fields?.size || configs.content.nodes['book'].fields.size}
                            />
                        </span>
                    </div>}

                    {!isMobile && content?.pages && <div className={`labelWrap pages`}>
                        <span className="label">Сторінок:</span>
                        <span className="labelValue">{content?.pages}</span>
                    </div>}

                    {content?.goodreads && <div className={`labelWrap goodreads`}>
                        <span className="label">GoodReads:</span>
                        <span className="labelValue">{content?.goodreads}<span className="max">/5</span></span>
                    </div>}

                </>}

                {!isMobile && <ShowActions content={content} belongsToLibrary={belongsToLibrary} onGetBook={handleGetBookOpen} onReturnBook={handleReturnBookOpen} />}
            </div>

            {isMobile && <div className={`labelWrap size`} style={{clear: 'both'}}>
                <span className="label">Розмір:</span>
                <span className="labelValue">
                    <FilterChip
                        className="textOnly"
                        value={content.size}
                        config={config?.childrenOptions?.['book']?.fields?.size || configs.content.nodes['book'].fields.size}
                    />
                </span>
            </div>}

            {isMobile && content?.pages && <div className={`labelWrap pages`}>
                <span className="label">Сторінок:</span>
                <span className="labelValue">{content?.pages}</span>
            </div>}

            {isMobile && content?.deposit && <div className={`labelWrap deposit`}>
                <span className="label">Депозит:</span>
                <span className="labelValue"><CurrencyFormated value={content?.idr?.price} currency={content?.idr?.currency}/> &nbsp;або&nbsp; <CurrencyFormated value={content?.deposit?.price} currency={content?.deposit?.currency}/></span>
            </div>}

            {isMobile && <ShowActions content={content} belongsToLibrary={belongsToLibrary} onGetBook={handleGetBookOpen} onReturnBook={handleReturnBookOpen} />}

            {/* GET BOOK */}
            <AdaptiveDialog open={openGetBook} onClose={handleGetBookClose} title={`Взяти книгу`}>
                <div className="BookDialog">
                    <Collapse in={requestInProgress}>
                        <div className="progressBlock">
                            <Preloader />
                        </div>
                    </Collapse>
   
                    <Collapse in={!requestInProgress && showRulesStep}>
                        <RulesStep
                            content={content}
                            belongsToLibrary={belongsToLibrary}
                            submit={acceptBaseRules}
                        />
                    </Collapse>

                    {/* <Collapse in={personalDataStep}>
                        <PersonDetailsStep
                            submit={submitPersonDetails}
                        />
                    </Collapse> */}

                    <Collapse in={!requestInProgress && showSanctionsStep}>
                        <SanctionsStep
                            content={content}
                            submit={acceptFinalRules}
                        />
                    </Collapse>

                    <Collapse in={!requestInProgress && depositStep}>
                        <DepositStep
                            belongsToLibrary={belongsToLibrary}
                            content={content}
                            submit={sendDeposit}
                        />
                    </Collapse>

                    <Collapse in={!requestInProgress && deliveryStep}>
                        <DeliveryStep
                            belongsToLibrary={belongsToLibrary}
                            content={content}
                            submit={sendDelivery}
                        />
                    </Collapse>

                    <Collapse in={!requestInProgress && finalStep}>
                        <FinalStep
                            belongsToLibrary={belongsToLibrary}
                            content={content}
                            handleGetBookClose={handleGetBookClose}
                        />
                    </Collapse>
                </div>
            </AdaptiveDialog>

            {/* RETURN BOOK */}
            <AdaptiveDialog open={openReturnBook} onClose={handleReturnBookClose} title={`Повернути книгу`}>
                {/* "${content.title}" */}
                <div className="BookDialog">
                    <Collapse in={requestInProgress}>
                        <div className="progressBlock">
                            <Preloader />
                        </div>
                    </Collapse>

                    <Collapse in={!requestInProgress && returnStep}>
                        <DepositReturnStep
                            belongsToLibrary={belongsToLibrary}
                            content={content}
                            submit={returnBookHandler}
                        />
                    </Collapse>

                    <Collapse in={!requestInProgress && finalReturnStep}>
                        <DepositReturnFinalStep
                            belongsToLibrary={belongsToLibrary}
                            content={content}
                            submit={handleReturnBookClose}
                        />
                    </Collapse>
                </div>
            </AdaptiveDialog>

            {isMobile && <Genres configs={configs} content={content}/>}

            {content?.notes && <div className="infoBlock notes alert">
                <InfoOutlinedIcon />
                <span>
                    Примітка власника:
                    &nbsp;
                    {content.notes}
                </span>
            </div>}

            {content.description && <div className='description'><CKEditorContent content={content.description} /></div>}
            {isMobile && <Gallery zoom content={content.gallery} />}

            {/* <BookDetails content={content}/> */}

            <ShowLinks content={content} history={meta?.history} belongsToLibrary={belongsToLibrary}/>

            {!isLibrary(userState?.user) && !hasFullAccess(userState?.user) && <div className="infoBlock">
                <HelpOutlineOutlinedIcon />
                <span>
                    Виникли проблеми або запитання під час користування бібліотекою? Зверніться в <span className="pseudoLink" onClick={supportClickHandle}>службу підтримки</span>
                </span>
            </div>}
        </>}
    </div>
}
